<template>
  <div class="update-phone">
    <div class="line-div">修改手机号</div>
    <div class="content-center cell-div">
      <div class="left-text">{{ type == 1 ? '原手机号码' : '新手机号码'}}</div>
      <div class="right-text">
        <el-input v-if="type == 1" disabled v-model="phone" placeholder="请输入手机号码"></el-input>
        <el-input v-else v-model="newPhone" placeholder="请输入手机号码"></el-input>
      </div>
    </div>
    <div class="content-center">
      <div class="left-text">验证码</div>
      <div>
        <el-input v-if="type == 1" v-model="code" placeholder="请输入验证码"></el-input>
        <el-input v-else v-model="newCode" placeholder="请输入验证码"></el-input>
      </div>
      <div v-if="count == 0" class="code-btn cursor-pointer" @click="getCode">获取验证码</div>
      <div v-else class="code-btn">{{count}}s后重发</div>
    </div>
    <div class="content-center">
      <div v-if="type == 1">
        <div v-if="code" class="btn content-center cursor-pointer" style="opacity: 1" @click="nextStep">下一步</div>
        <div v-else class="btn content-center" style="opacity: 0.5">下一步</div>
      </div>
      <div v-if="type == 2">
        <div v-if="newCode && newPhone" class="btn content-center cursor-pointer" style="opacity: 1" @click="nextStep">完成</div>
        <div v-else class="btn content-center" style="opacity: 0.5">完成</div>
      </div>

    </div>
    <div class="content-center">
      <div class="btn-return content-center" @click="lastStep">返回上一步</div>
    </div>

    <GetCode v-if="showVerCode" :showVerCode="showVerCode" @successCode="successCode" @closeDialog="closeDialog" :phone="type == 1 ? phone : newPhone " type="up" />
  </div>
</template>

<script>
import GetCode from './GetCode'
import { httpAjax } from "@/api/ajax";


export default {
  name: 'UpdatePhone',
  components: {
    GetCode,
  },
  props: {
    phone: Number | String
  },
  data() {
    return {
      code: '',
      type: 1,
      newPhone: '',
      newCode: '',
      showVerCode: false,
      count: 0,
      timer: null,
    }
  },
  created() {},
  methods: {
    //下一步
    nextStep() {
      if(this.type == 1){
        httpAjax({
          url:'/services/user/checkVerifyCode',
          method:'get',
          data: {
            verifyCode: this.code
          }
        }).then((response) => {
          if(response.success){
            this.type = 2
            this.count = 0
          } else {
            this.$message({
              message: response.msg,
              type: 'error'
            }) 
          }
        })
      } else if(this.type == 2){
        httpAjax({
          url:'/services/user/checkPhone',
          method:'get',
          data: {
            phone: this.newPhone,
          }
        }).then((response) => {
          if(response.success){
            httpAjax({
              url:'/services/user/changePhone',
              method:'post',
              data: {
                newPhone: this.newPhone,
                verifyCode: this.newCode
              }
            }).then((response) => {
              if(response.success) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.$emit('lastStep')
              } else {
                this.$message({
                  message: response.msg,
                  type: 'error'
                })
              }
            });
          } else {
            this.$message({
              message: response.msg,
              type: 'error'
            })
          }
        })
      }
    },
    // 关闭弹窗
    closeDialog(){
      this.showVerCode = false
    },
    // 倒计时
    timeFun() {
      this.count = 60;
      this.timer = setInterval(() => {
        if(this.count === 0) {
          clearInterval(this.timer)
        } else {
          this.count--;
        }
      }, 1000);
    },
    // 获取验证码
    getCode(){
      this.showVerCode = true
    },
    // 获取验证码成功
    successCode(){
      clearInterval(this.timer)
      this.timeFun()
    },
    
    // 上一步
    lastStep(){
      this.count = 0
      if(this.type == 1){
        this.$emit('lastStep')
      }
      if(this.type == 2) {
        this.type = 1
      }
    }
  },
}
</script>

<style scoped lang='less'>
.update-phone {
  .el-input {
    width: 290px;
    height: 32px;
    /deep/ .el-input__inner {
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
    }
  }

  .code-btn {
    width: 80px;
    height: 32px;
    background: #1170eb;
    border-radius: 4px;
    margin-left: 16px;

    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 32px;
    text-align: center;
  }

  .line-div {
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: #f7f7fa;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    padding-left: 16px;
  }

  .cell-div {
    margin-top: 64px;
    margin-bottom: 24px;

    .right-text {
      .el-input {
        width: 386px;
      }

      /deep/ .el-input__inner {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
      }
    }
  }

  .left-text {
    width: 70px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
    text-align: right;
    margin-right: 16px;
  }

  .btn {
    width: 386px;
    height: 32px;
    margin-top: 40px;
    margin-left: 86px;

    background: #1170eb;
    border-radius: 4px;

    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 32px;
  }
  .btn-return {
    width: 386px;
    height: 32px;
    margin-top: 16px;
    margin-left: 86px;

    background: #fff;
    border-radius: 4px;

    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333;
    line-height: 32px;
    border: 1px solid #dedede;
    cursor: pointer;
  }
}
</style>
